import React from 'react';
import Dotdotdot from 'react-dotdotdot';

import Tooltip from './tooltip';


const TextOverFlowToolTip = ({markup, clamp, charMaxLength, className}) => {
    const violatorMsg =
        <h4>
            <Dotdotdot clamp={clamp} >
                <p dangerouslySetInnerHTML={markup}></p>
            </Dotdotdot>
        </h4>

    return(
        <div className={`${className ? ' '+className : ''}`}>
            {
                (markup.__html && markup.__html.length >= charMaxLength) ?
                <Tooltip label={violatorMsg}>
                    <p dangerouslySetInnerHTML={markup}></p>
                </Tooltip>
                : violatorMsg
            }
        </div>
    );
}

export default TextOverFlowToolTip;
